import { FuseAnimate } from "@fuse";
import { List, ListItem, ListItemText, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import clsx from "clsx";
import Planos from "app/Planos/index.json";
import React from "react";
import { checkPlano } from "app/Core/Helpers";

const styles = (theme) => ({
   root: {
      width: "100%",
      backgroundColor: theme.palette.background.paper,
   },
   nested: {
      paddingLeft: 8,
   },
   item: {
      height: 40,
      borderRadius: "0 20px 20px 0",
      paddingRight: 12,
      "&.active": {
         backgroundColor: theme.palette.secondary.main,
         color: theme.palette.secondary.contrastText + "!important",
         transition: "border-radius .15s cubic-bezier(0.4,0.0,0.2,1)",
         "& .list-item-text-primary": {
            color: "inherit",
         },
         "& .list-item-icon": {
            color: "inherit",
         },
      },
      "&.square, &.active.square": {
         width: "100%",
         borderRadius: "0",
      },
      "& .list-item-icon": "folder",
      "& .list-item-text": {},
      color: theme.palette.text.primary,
      textDecoration: "none!important",
   },
});

const TABS = [
   { id: 0, nome: "Prontuário", icon: "atendimento", "show": "true" },
   { id: 9, nome: "Documentos", icon: "paper", "show": "true" },
   { id: 4, nome: "Arquivos", icon: "file", "show": Planos.arquivos.show },
   { id: 5, nome: "Galeria", icon: "image", "show": Planos.arquivos.show },
   { id: 1, nome: "Relacionamento", icon: "user_settings", "show": Planos.atendimento.relacionamento },
];

class EmpresaPessoaProntuarioNavbar extends XAPPComponent {

   render() {
      const { classes, tabValue, handleChangeTab, settings } = this.props;

      return (
         <FuseAnimate animation="transition.slideUpIn" delay={400}>
            <div className="flex-auto border-l-1 border-solid">
               <List>
                  {TABS.map((tab) => {
                     if (checkPlano(tab.show, settings)) {
                        return (
                           <ListItem
                              button
                              key={"ListItemTab_" + tab.id}
                              className={clsx(
                                 classes.item,
                                 "list-item",
                                 "list-item-icon",
                                 tabValue === tab.id && "active"
                              )}
                              onClick={(ev) => handleChangeTab(ev, tab.id)}
                           >
                              <XAPPButton
                                 className="list-item-icon p-0 text-18"
                                 color="action"
                                 onClick={() => { }}
                                 icon={tab.icon}
                                 type={"icon"}
                                 noHover={true}
                              />
                              <ListItemText
                                 primary={tab.nome}
                                 disableTypography={true}
                              />
                           </ListItem>
                        );
                     }
                  })}
               </List>
            </div>
         </FuseAnimate>
      );
   }
}

export default withStyles(styles, { withTheme: true })(EmpresaPessoaProntuarioNavbar);
